export default "__VITE_ASSET__DjfktvA___"